/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Gym_AccessInputs */

const en_service_type_gym_access = /** @type {(inputs: Service_Type_Gym_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gym membership and day passes`)
};

const pl_service_type_gym_access = /** @type {(inputs: Service_Type_Gym_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siłownia: karnet i wejścia`)
};

/**
* | output |
* | --- |
* | "Gym membership and day passes" |
*
* @param {Service_Type_Gym_AccessInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_gym_access = /** @type {((inputs?: Service_Type_Gym_AccessInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Gym_AccessInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_gym_access(inputs)
	return en_service_type_gym_access(inputs)
});